import { AxiosRequestConfig } from "axios";
import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler } from "../../../shared/services/errors/erros-handler";
import { toSlug } from "../../../shared/utils";

const findAll = async (
    filtro?: string,
    pagina = 0,
    limite = 10,
    campo?: string,
    valor?: string
): Promise<{ items: any[]; totalItems: number }> => {
    try {
        let query = `/box-message?page=${pagina + 1}&limit=${limite}`;
        if (campo && valor) {
            query += `&campo_pesquisa=${campo}&tipo_pesquisa=in&valor_pesquisa=${valor}`;
        } else if (filtro?.trim()) {
            const filtroPesquisa = toSlug(filtro);
            query += `&campo_pesquisa=name&tipo_pesquisa=in&valor_pesquisa=${filtroPesquisa}`;
        }
        const result = await baseApiService.get(query);
        const responseData = result.data?.data;
        return {
            items: Array.isArray(responseData?.items) ? responseData.items : [],
            totalItems: responseData?.meta?.totalItems || 0,
        };
    } catch (error) {
        console.error("Erro ao buscar mensagens:", error);
        throw errosHandler(error);
    }
};

const detalhar = async (id: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/box-message/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const deletar = async (id: string): Promise<any> => {
    try {
        const result = await baseApiService.delete(`/box-message/${id}`);
        return result.data?.data;
    } catch (error) {
        console.error("Erro ao detalhar banco:", error);
        throw errosHandler(error);
    }
};

export const caixaDeEntradaService = {
    detalhar,
    findAll,
    deletar,
};